import { TStore } from './types';

export const initialState: TStore = {
  site: {
    pages: {},
    templates: {},
    icons: {},
    expressions: {},
    settings: {},
    locales: {},
    regions: {},
  },
  ui: {
    locale: 'ru',
    states: {},
    collections: {},
  },
  access: {
    me: undefined,
    jwt: undefined,
    roles: {},
  },
  units: {
    users: {},
    userCards: {},
  },
  api: {},
};
